import type { GridApi } from 'ag-grid-community';
import React from 'react';

export interface AgGridContextType {
  gridApi?: GridApi | null;
  // `this: void` keeps the method-syntax bivariance (so React state setters
  // and plain callbacks both fit) while satisfying
  // @typescript-eslint/unbound-method.
  setGridApi(this: void, gridApi?: GridApi): void;
}

export const AgGridContext = React.createContext<AgGridContextType>({
  gridApi: null,
  setGridApi: () => {
    console.info('setGridApi not provided');
  },
});
